export default __webpack_public_path__ + "static/media/sp_card_setting_dark.8a48ac32.svg";